import { Modal } from 'components/core';
import { FC } from 'react';
import { LoadingSpinner } from 'styles/sharedStyles';
import { Styled } from '.';
import { useI18n } from '../../contexts/i18n';

export const IteroOrderLoadingModal: FC = () => {
  const i18n = useI18n();
  return (
    <Modal>
      <Styled.ErrorContainer>
        <LoadingSpinner width="35px" height="35px" isPrimary={true} />
        <Styled.LoadingMessage>
          {i18n['Please wait while your order is being processed...']}
        </Styled.LoadingMessage>
      </Styled.ErrorContainer>
    </Modal>
  );
};
